import { createContext } from 'react';

/**
 * SSR viewport width from {@link resolveSsrViewportWidth} (cookie / Client Hints), set once by AppShell.
 * Supplies SSR viewport width so `AppProvider` breakpoint state matches `tn_vw` on SSR and hydration.
 *
 * `undefined` — consumer is outside the provider (fall back to document cookie / matchMedia only).
 * `null` — request had no usable width (same as AppProvider’s `ssrViewportWidth` default).
 */
export const SsrViewportWidthContext = createContext<number | null | undefined>(undefined);
